export const handleChangeDataAccumulativePage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_ACCUMULATIVE', name, value
});